import { render, staticRenderFns } from "./MissingItemsList.vue?vue&type=template&id=79fed172&"
import script from "./MissingItemsList.vue?vue&type=script&lang=js&"
export * from "./MissingItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports